import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Box } from 'foundations-components/transitional/components/Box';
import { Link } from 'foundations-components/transitional/components/Link';
import LearnMoreModalListItem from '../base/LearnMoreModalListItem';
import LearnMoreModal from '../base/LearnMoreModal';
import { useModalTracker } from '../../../hooks/tracking';
import { KNOWLEDGE_BASE_INSTALL_WORDPRESS_PLUGIN } from '../../../utils/urls';
// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module 'bender-url!../../../../images/... Remove this comment to see the full error message
import wordpressImage from 'bender-url!../../../../images/wordpress.svg';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const WordPressModal = ({
  onClose
}) => {
  const {
    trackLink
  } = useModalTracker('WordPressModal');
  return /*#__PURE__*/_jsxs(LearnMoreModal, {
    footer: /*#__PURE__*/_jsx(Link, {
      external: true,
      href: KNOWLEDGE_BASE_INSTALL_WORDPRESS_PLUGIN,
      onClick: () => trackLink('install wordpress plugin article'),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "setup-guide-components.modal.readInstructions"
      })
    }),
    heading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "setup-guide-components.modal.wordPress.heading"
    }),
    illustrationSrc: wordpressImage,
    onClose: onClose,
    children: [/*#__PURE__*/_jsx(Box, {
      marginBlockEnd: "500",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "setup-guide-components.modal.wordPress.description"
      })
    }), /*#__PURE__*/_jsx(LearnMoreModalListItem, {
      message: "setup-guide-components.modal.wordPress.li1"
    }), /*#__PURE__*/_jsx(LearnMoreModalListItem, {
      message: "setup-guide-components.modal.wordPress.li2"
    }), /*#__PURE__*/_jsx(LearnMoreModalListItem, {
      message: "setup-guide-components.modal.wordPress.li3"
    }), /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx("strong", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "setup-guide-components.modal.wordPress.footer"
        })
      })
    })]
  });
};
WordPressModal.propTypes = {
  onClose: PropTypes.func
};
export default WordPressModal;